import request from "@/utils/oms-request";

// 唛头类型
export const listMarkType = () =>
    request({
        url: `/mark/markType`,
        method: "get"
    });

// 号码类型
export const listMarkNumber = () =>
    request({
        url: `/mark/markNumber`,
        method: "get"
    });

// 新增唛头
export const  save = (data: any) =>
    request({
        url: `/mark`,
        method: "put",
        data
    });

// 列表查询
export const search = (params: any) =>
    request({
        url: `/mark`,
        method: "get",
        params,
    });

// 删除唛头
export const deleted = (id: string) =>
    request({
        url: `/mark/${id}`,
        method: "delete"
    });

//锁定唛头
export const locked = (id: string) =>
    request({
        url: `/mark/${id}/locked`,
        method: "put"
    });

export const listMark = (params) =>
    request({
        url: `/mark/list`,
        method: "get",
        params
    });

export const queryMarkByBrandsAndCustomer = (params) =>
    request({
        url: `/mark/list`,
        method: "post",
        params
    });

// 首次创建客人唛头
export const firstUploadMark = (data: any) =>
    request({
        url: `/mark/first/upload`,
        method: "put",
        data
    });